import { VenueTypeModel } from './../models/venue_type.model';
import { JsonMapper } from '../modules/mapper/json.mapper';
import { TransferHttp } from '../modules/transfer-http/transfer-http';
import { UtilHelper } from '../helpers/util.helper';
import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { BaseService } from './base.service';
import { PaginationModel, ResponseModel } from '../models';
import { REST_API } from '../modules/constants';

@Injectable()
export class VenueTypeService extends BaseService {

    constructor(public http: TransferHttp) {
        super(http);
    }

    /**
     * Get list variable
     * @returns {Promise<T>|Promise<U>}
     */
    public findAll(paging: boolean = true, filter: any = {}): Promise<PaginationModel> {

        if (!paging) {
            filter.offset = '';
            filter.limit = '';
        }
        let queryString = UtilHelper.parseFilterToString(filter);
        return this.makeHttpGet(`${this.apiUrl}/` + REST_API.VENUE_TYPE + '?' + queryString)
            .then((res) => {
                res.data = JsonMapper.deserialize(VenueTypeModel, res.data);
                return res;
            });
    }
}